import axios from "axios";

import React, { 
	useState, useEffect
} from "react";

import { 
	NavLink 
} from "react-router-dom";

import {
	TextField,
	Button,
	Grid,
	Card,
	Breadcrumbs,
	Typography
} from "@material-ui/core";

import { 
	makeStyles, 
	withStyles 
} from "@material-ui/core/styles";

import {
	get_cookies, 
	isLoggedIn
} from "../../../../components/Cookies/Cookies";

import Autocomplete from "@material-ui/lab/Autocomplete";
import ReceiptIcon from '@material-ui/icons/Receipt';

import LoadingModal from "../../../../components/Modal/LoadingModal";
import MessageBox from "../../../../components/MessageBox/MessageBox";

const useStyles = makeStyles({
	field: {
		width: "100%",
		marginBottom: "1rem",
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem",
	},
	buttonContainer: {
		textAlign: "right",
	},
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #33993312",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	voucher_image: {
		width: "50%",
	}
});

const ColorButton = withStyles(() => ({
	root: {
		color: "#fff",
		backgroundColor: "#4caf50",
		"&:hover": {
			backgroundColor: "#fff",
			color: "#4caf50",
		},
	},
}))(Button);

const JCPortalQuestVoucherRedemption = () => {
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const classes = useStyles();

	const [voucherCode, setVoucherCode] = useState("");
	const [voucherClaimed, setVoucherClaimed] = useState(0);
	const [idno, setIdno] = useState("");
	const [questExist, setQuestExist] = useState(0);
	const [questImage, setQuestImage] = useState("");
	const [questTitle, setQuestTitle] = useState("");
	const [distributorClaimed, setDistributorClaimed] = useState("");
	const [dateClaimed, setDateClaimed] = useState("");
	const [questCode, setQuestCode] = useState("");
	const [fromDate, setFromDate] = useState("");
	const [toDate, setToDate] = useState("");
	const [description, setDescription] = useState("");
	const [processedBy, setProcessedBy] = useState("");
	const [branches, setBranches] = useState([]);
	const [selectedBranch, setSelectedBranch] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsgBoxContent] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	const [username, setUsername] = useState(get_cookies("username"));
	const [firstname, setFirstname] = useState(get_cookies("firstname"));
	const [lastname, setLastname] = useState(get_cookies("lastname"));

	const getBranches = async () => {
		setIsLoading(true);

		await axios.get(process.env.REACT_APP_API_URL + "get_branches", {})
		.then((res) => {
			var data = res.data.data;

			setBranches(data);

			setIsLoading(false);
		})
		.catch((error) => {
			console.log(error.message);
			
			setIsLoading(false);
		});
	};

	const getQuestVoucherData = async () => {
		setIsLoading(true);

		await axios
		.get(process.env.REACT_APP_API_URL + "get_quest_voucher_data", {
			params:{
				voucher_code: voucherCode,  //branchIdNo
			}
		})
		.then((res) => {
			var data = res.data.data;
			
			if(data !== null){
				var quest = data.quest;
				var member_main = data.member_main;
				var full_name = member_main.fname+' '+member_main.lname

				setIdno(data.idno);
				setQuestImage(quest.image_url);
				setQuestTitle(quest.title);
				setDistributorClaimed(full_name);
				setDateClaimed(data.date_claimed);
				setQuestCode(quest.code);
				setFromDate(quest.fromdate);
				setToDate(quest.todate);
				setDescription(quest.remarks);
				setProcessedBy(data.admin_user);
				setVoucherClaimed(data.is_claimed);

				if(data.is_claimed == 0){
					getBranches();
				}

				setQuestExist(1);
			}
			else{
				setQuestExist(0);
			}

			setIsLoading(false);
		})
		.catch((error) => {
			console.log(error.message);

			setIsLoading(false);
		});

	};

	const redeemQuestVoucher = async () => {
		setIsLoading(true);

		const formData = new FormData();
		formData.append("voucher_code", voucherCode);
		formData.append("idno", idno);
		formData.append("branch_redeemed", selectedBranch);
		formData.append("username_admin", username);
		formData.append("first_name_admin", firstname);
		formData.append("last_name_admin", lastname);

		await axios.post(process.env.REACT_APP_API_URL + 'redeem_quest_voucher', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		}).then((res) => {
			setIsLoading(false);

			getQuestVoucherData();

			setShowMsgBox(true);
			setMsgBoxContent("Voucher redeemed successfully");
			setMsgType("success");
			setTimeout(() => {
				setShowMsgBox(false);
			}, 2000)
		}).catch((error) => {
			console.log(error.message);

			setShowMsgBox(true);
			setMsgBoxContent("Something went wrong. Please contact administrator.");
			setMsgType("error");
			setTimeout(() => {
				setShowMsgBox(false);
			}, 2500)

			setIsLoading(false);
		});
	};

	const handleBranchChange = (event, newValue) => {
		setSelectedBranch(newValue.idno);
	};

	return (
		<div className="page">
			<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
			<LoadingModal showModal={isLoading} />

			<div className="page-header">
				<div className="page-icon">
					<ReceiptIcon />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/purchases">
						<h2 className="header-title">Settings</h2>
					</NavLink>
					<Typography color="textPrimary">JC Portal Quest Voucher Redemption</Typography>
				</Breadcrumbs>
			</div>
        
			<div className="page-container">
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
					<Grid
						container
						spacing={0}
						style={{ justifyContent: "flex-end" }}
					>
						<Grid item xs={8}>
						<div className={classes.title}>JC Portal Quest Voucher Redemption</div>
						</Grid>
						<Grid item xs={2} style={{ textAlign: "right" }}></Grid>
						<Grid item xs={2} className={classes.buttonContainer}></Grid>
						<Grid container spacing={2}>
						<Grid item xs="12" lg="12" xl="12">
							<form noValidate autoComplete="off">
								<Grid container style={{ marginTop: '30px' }}>
									<Grid item xs={12} lg={4} xl={2} style={{ paddingLeft: '5px', paddingRight: '5px'}}>
										<TextField
											id="outlined-basic"
											label="Enter Voucher Code"
											variant="outlined"
											type="text"
											className={classes.field}
											onChange={(e) => {
												setVoucherCode(e.target.value);
											}}
										/>
									</Grid>

									<Grid item xs={12} lg={4} xl={2} style={{ paddingLeft: '5px', paddingRight: '5px'}}>
										<ColorButton
											variant="contained"
											color="primary"
											classes={{
												root: classes.root,
												disabled: classes.disabled,
											}}
											onClick={getQuestVoucherData}
										>
											Search Voucher
										</ColorButton>
									</Grid>
								</Grid>

								<hr/>
					
								{questExist ? (
									<div>
										<Grid container justifyContent="center">
											<Grid item xs={8} lg={6} xl={4} style={{ textAlign: 'center' }}>
												<img 
													className={classes.voucher_image}
													src={questImage}
												/>
											</Grid>
										</Grid>

										<hr/>

										<Grid 
											container 
											spacing={3} 
											style={{ 
												marginTop: '10px',
												marginBottom: '40px'
											}}
										>
											<Grid container item>
												<Grid item xs={12}>
													<Typography 
														variant="h3" 
														align="center"
													>
														{questTitle}
													</Typography>
												</Grid>
											</Grid>
										</Grid>

										<Grid 
											container 
											spacing={3} 
											style={{ 
												marginTop: '5px',
											}}
										>
											<Grid container item spacing={3}>
												<Grid item xs={6}>
													<Typography>
													<strong>Distributor Claimed:</strong>
													<br />
													{distributorClaimed}
													</Typography>
												</Grid>
												<Grid item xs={6}>
													<Typography>
													<strong>Date Claimed:</strong>
													<br />
													{dateClaimed}
													</Typography>
												</Grid>
											</Grid>
										</Grid>

										<hr/>

										<Grid 
											container 
											spacing={3} 
											style={{ 
												marginTop: '5px',
											}}
										>
											<Grid container item>
												<Grid item xs={6}>
													<Typography>
														<strong>Quest Code:</strong>
														<br />
														{questCode}
													</Typography>
												</Grid>
											</Grid>

											<Grid container item spacing={3}>
												<Grid item xs={6}>
													<Typography>
													<strong>From Date:</strong>
													<br />
													{fromDate}
													</Typography>
												</Grid>
												<Grid item xs={6}>
													<Typography>
													<strong>To Date:</strong>
													<br />
													{toDate}
													</Typography>
												</Grid>
											</Grid>

											<Grid container item>
												<Grid item xs={12}>
													<Typography>
														<strong>Description:</strong>
														<br />
														{description}
													</Typography>
												</Grid>
											</Grid>
   		 								</Grid>

										{voucherClaimed ? (
											<div>
												<hr/>
												<Grid 
													container 
													spacing={3}
													style={{ 
														marginTop: '5px',
													}}
												>
													<Grid container item>
														<Grid item xs={12}>
															<Typography>
																<strong>Processed By:</strong>
																<br />
																{processedBy}
															</Typography>
														</Grid>
													</Grid>
												</Grid>

											</div>

										) : (
											<div>
												<hr/>
												<Grid 
													container 
													spacing={3} 
													style={{ 
														marginTop: '5px',
													}}
												>
													<Grid container item justifyContent="center">
														<Grid item xs={6} style={{ textAlign: 'center' }}>
															<Typography style={{ marginBottom: '15px' }}>
																<strong>Branch Redeemed:</strong>
																<br />
															</Typography>
															<Autocomplete
																id="auto-complete-1"
																autoComplete
																style={{ marginBottom: "1.5rem" }}
																includeInputInList
																onChange={handleBranchChange}
																options={branches}
																getOptionLabel={(option) => option.idno} // Adjust this line to use the correct property
																renderInput={(params) => (
																	<TextField {...params} label="Select a branch" />
																)}
															/>
															<ColorButton
																variant="contained"
																color="primary"
																classes={{
																	root: classes.root,
																	disabled: classes.disabled,
																}}
																onClick={redeemQuestVoucher}
															>
																Redeem Voucher
															</ColorButton>
														</Grid>
													</Grid>
												</Grid>
											</div>
										)}
										
									</div>
								) : (
									<div>
										<Grid 
											container 
											spacing={3} 
											style={{ 
												marginTop: '10px',
												marginBottom: '40px'
											}}
										>
											<Grid container item>
												<Grid item xs={12}>
													<Typography 
														variant="h3" 
														align="center"
													>
														No Quest Voucher Found
													</Typography>
												</Grid>
											</Grid>
										</Grid>
									</div>
								)} 
							</form>
						</Grid>
						</Grid>
					</Grid>
					</div>
				</Card>
			</div>
		</div>
	);
};

export default JCPortalQuestVoucherRedemption;
